import React, { useContext, useEffect, useRef, useState } from "react";
import Map from "../Components/Maps/LiveMap";
import socketIO from "socket.io-client";
import moment from "moment";
import Card from "../Components/Card";
import { UserIcon } from "@heroicons/react/24/outline";
import { decimalFormatter } from "../Utils/Formatter";
import SocketContext from "../Contexts/SocketContext";
const HistoricMap = () => {
  const mapRef = useRef(null);
  const selectedUserId = useRef(null);
  const [refresh, setRefresh] = useState(false);
  const [mapLoad, setMapLoad] = useState(false);
  const [flight, setFlight] = useState(null);
  const [flightCount, setFlightCount] = useState();
  const recentFlightData = useRef(null);
  const socket = useContext(SocketContext);

  useEffect(() => {
    if (recentFlightData.current && selectedUserId.current) {
      setFlight(
        recentFlightData.current.points.find(
          (flight) => flight.user_id === selectedUserId.current
        )
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedUserId.current]);
  useEffect(() => {
    if (socket) {
      socket.on("recentFlights", (data) => {
        recentFlightData.current = data;
        setFlightCount(data?.points?.length);
        setRefresh((prev) => !prev);
        if (data?.flightRoutes?.length > 0) {
          let geoJson = {
            type: "FeatureCollection",
            features: data.flightRoutes.map((line) => {
              return {
                type: "Feature",
                properties: {},
                geometry: {
                  type: "LineString",
                  coordinates: line.map((point) => [point.lng, point.lat]),
                },
              };
            }),
          };
          mapRef.current.getSource("route")?.setData(geoJson);
        }
        if (data?.points?.length > 0) {
          let geoJson = {
            type: "FeatureCollection",
            features: data.points.map((flight, i) => {
              return {
                type: "Feature",
                geometry: {
                  type: "Point",
                  coordinates: [flight.lng, flight.lat],
                },
                properties: {
                  opacity: 1,
                  icon: `acft_${flight.acft}`,
                  rotation: 90 - flight.hdg,
                  user_id: flight.user_id,
                },
              };
            }),
          };
          mapRef.current.getSource("points")?.setData(geoJson);
        }
      });
      socket.emit("showRecentFlights");
    }
  }, [socket, mapLoad]);
  return (
    <>
      <h1 className="text-2xl font-bold mb-4">Recent Flights</h1>
      <div className="flex justify-between items-center mb-8">
        <p className=" text-sm text-gray-600 whitespace-pre-line">
          {`Explore the recent sky traffic with this map, showcasing aircraft movements this day.\nDive into patterns, densities, and trends as you journey through a day in aviation.`}
        </p>
        <div>
          <div className="flex items-center space-x-2  border-gray-200 rounded-md p-1 px-4">
            <p>{flightCount}</p>
            <UserIcon className="h-8 w-8" />{" "}
          </div>
          <p className="text-center text-sm text-gray-400 mt-1">today</p>
        </div>
      </div>
      <div className="h-full w-full relative pb-12">
        <Map
          ref={mapRef}
          onLoad={() => setMapLoad(true)}
          onAirplaneSelect={(id) => {
            selectedUserId.current = id;
            setRefresh((prev) => !prev);
          }}
        />

        {flight && (
          <div className="text-sm absolute inset-4 max-w-max max-h-max">
            <Card>
              <div className="flex justify-between space-x-2">
                <p>Aircraft </p>
                <p className="font-bold">{flight.acft}</p>
              </div>

              <div className="flex justify-between space-x-2">
                <p>Total distance: </p>
                <p className="font-bold">
                  {decimalFormatter.format(flight.totalDistance)} km
                </p>
              </div>

              <div className="flex justify-between space-x-2">
                <p>Playtime: </p>
                <p className="font-bold">
                  {decimalFormatter.format(flight.duration.toFixed(2))} h
                </p>
              </div>

              <span className="text-xs">
                <p className="text-gray-500 pt-2 mt-2 border-t  border-gray-200">
                  {flight.user_id}
                </p>
                <div className="flex justify-between space-x-2">
                  <p>Played from:</p>
                  <p>{moment.utc(flight.time).format(" HH:mm")} o'clock</p>
                </div>
                <div className="flex justify-between space-x-2">
                  <p>until:</p>
                  <p>{moment.utc(flight.time_end).format("HH:mm")} o'clock</p>
                </div>
              </span>
            </Card>
          </div>
        )}
      </div>
    </>
  );
};

export default HistoricMap;
